export default __webpack_public_path__ + "static/media/Astro-king.03ca91f6.png";